import { render } from "./side_drawer.vue?vue&type=template&id=650ad1ba"
import script from "./side_drawer.js?vue&type=script&lang=js"
export * from "./side_drawer.js?vue&type=script&lang=js"

import "./side_drawer.vue?vue&type=style&index=0&id=650ad1ba&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__